import { render, staticRenderFns } from "./Q&A.vue?vue&type=template&id=1574fdaa&scoped=true&"
import script from "./Q&A.vue?vue&type=script&lang=js&"
export * from "./Q&A.vue?vue&type=script&lang=js&"
import style0 from "./Q&A.vue?vue&type=style&index=0&id=1574fdaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574fdaa",
  null
  
)

export default component.exports